import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Container } from "react-bootstrap";
import { Get } from "../../Axios/AxiosFunctions";
import { BaseURL } from "../../config/apiUrl";
import styles from "./PrivacyPolicy.module.css";
import parse from "html-react-parser";
import { Loader } from "../../Component/Loader";
const PrivacyPolicy = () => {
  const [responseData, setResponseData] = useState(null);
  const [loader, setLoader] = useState(false);

  const getData = async () => {
    setLoader(false);

    const response = await Get(BaseURL("privacy-policy"));
    setLoader(true);

    if (response != undefined) {
      setResponseData(response?.data?.data?.content);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <section className={`${styles.section} ${!loader && styles.loaderCss}`}>
      {!loader ? (
        <Loader />
      ) : (
        <Container className={styles.container}>
          <div className={styles.content}>
            {/* {responseData && parse(responseData)} */}
            What is Lorem Ipsum? Lorem Ipsum is simply dummy text of the
            printing and typesetting industry. Lorem Ipsum has been the
            industry's standard dummy text ever since the 1500s, when an unknown
            printer took a galley of type and scrambled it to make a type
            specimen book. It has survived not only five centuries, but also the
            leap into electronic typesetting, remaining essentially unchanged.
            It was popularised in the 1960s with the release of Letraset sheets
            containing Lorem Ipsum passages, and more recently with desktop
            publishing software like Aldus PageMaker including versions of Lorem
            Ipsum.
          </div>
        </Container>
      )}
    </section>
  );
};

export default PrivacyPolicy;
